import { EnergyFeedbackType } from '@demind-inc/core';
import { DataTFunction } from '../../../DataView/i18n';

export const getEmaDoneText = (t: DataTFunction, feedbackType: EnergyFeedbackType) => {
  if (['high', 'strong'].includes(feedbackType)) {
    return t('calendar.eventMenu.energyGreat');
  } else if (feedbackType === 'medium') {
    return t('calendar.eventMenu.energyMedium');
  } else {
    return t('calendar.eventMenu.energyLow');
  }
};
